import React from 'react';
import { Users } from 'lucide-react';
import { useMetadata } from '../../context/MetadataContext';
import { useGameState } from '../../context/GameStateContext';
import CountryFlag from '../../utils/CountryFlag';
import styles from './TournamentDetail.module.css';

const TournamentDetail = ({ tournamentData, onBack }) => {
  const { getText } = useMetadata();
  const { joinTournament } = useGameState();

  console.log('details: ', tournamentData)
  const handleBack = () => {
    if (onBack) {
      onBack();
    }
  };

  const handleJoinClick = async () => {
    if (tournamentData && tournamentData.share_token) {
      try {
        await joinTournament(tournamentData.share_token);
      } catch (error) {
        // Error handling is done in the GameStateContext
        console.error('Failed to join tournament:', error);
      }
    } else {
      console.error('No share token found for tournament');
    }
  };

  // Format date from timestamp
  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  if (!tournamentData) {
    return (
      <div className={styles.loading}>
        {getText('tournament_detail.no_data')}
      </div>
    );
  }

  return (
    <div className={styles.tournamentDetailContainer}>
      
      <div className={styles.tournamentCard}>
        <div className={styles.tournamentIcon}>
          <div className={styles.peopleIcon}>
            <Users size={32} />
          </div>
        </div>
        <div className={styles.tournamentInfo}>
          <h3 className={styles.tournamentName}>{tournamentData.name}</h3>
          
          <div className={styles.detailsGrid}>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>
                {getText('common_text.puzzles')}
              </span>
              <span className={styles.detailValue}>{tournamentData.puzzle_count}</span>
            </div>
            
            {tournamentData.styles && (
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>
                  {getText('common_text.styles')}
                </span>
                <span className={styles.detailValue}>
                  {tournamentData.styles}
                </span>
              </div>
            )}
            
            {(tournamentData.difficulties || tournamentData.difficulty) && (
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>
                  {getText('common_text.difficulties')}
                </span>
                <span className={styles.detailValue}>
                  {tournamentData.difficulties ? tournamentData.difficulties.join('-') : tournamentData.difficulty}
                </span>
              </div>
            )}
            
            {(tournamentData.expires_ts || tournamentData.expiry_date) && (
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>
                  {getText('tournament_mode.expires')}
                </span>
                <span className={styles.detailValue}>
                  {tournamentData.expires_ts ? formatDate(tournamentData.expires_ts) : 
                   new Date(tournamentData.expiry_date).toLocaleDateString()}
                </span>
              </div>
            )}
            
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>
                {getText('tournament_mode.participants')}
              </span>
              <span className={styles.detailValue}>
                {tournamentData.player_count || 
                 (tournamentData.participants && tournamentData.participants.length) || 0}
              </span>
            </div>
            
            {tournamentData.country_codes && tournamentData.country_codes.length > 0 && (
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>
                  {getText('common_text.countries')}
                </span>
                <div className={styles.flagsContainer}>
                  {tournamentData.country_codes.map((code) => (
                    <CountryFlag key={code} countryCode={code} />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      
      <div className={styles.actionButtons}>
        <button 
          className={styles.backButton}
          onClick={handleBack}
          data-testid="back-button"
        >
          {getText('common_text.back')}
        </button>
        <button 
          className={styles.joinButton}
          onClick={handleJoinClick}
          data-testid="join-button"
        >
          {getText('actions.action_join')}
        </button>
      </div>
    </div>
  );
};

export default TournamentDetail;
